import { render, staticRenderFns } from "./mempool.vue?vue&type=template&id=0d88bfcf&"
import script from "./mempool.vue?vue&type=script&lang=js&"
export * from "./mempool.vue?vue&type=script&lang=js&"
import style0 from "./mempool.vue?vue&type=style&index=0&id=0d88bfcf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports